import React from "react";
import { Route, Navigate } from "react-router-dom";
import Login from "../pages/Login";
import Register from "../pages/RegisterNew";
import SetupAccount from "../pages/SetupAccount";
import OnboardingQuestions from "../pages/OnboardingQuestions";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import SetupPassword from "../pages/SetupPassword";
import ChangePassword from "../pages/ChangePassword";
import OAuthSuccess from "../pages/OAuthSuccess";
import AdminLogin from "../pages/admin/AdminLogin";
import AdminUnlock from "../pages/admin/AdminUnlock";

/**
 * Public auth routes — no PrivateRoute wrapper required.
 */
export const AuthRoutes = () => (
  <>
    <Route path="/login" element={<Login />} />
    <Route path="/admin/login" element={<AdminLogin />} />
    <Route path="/register" element={<Register />} />
    <Route path="/setup-account" element={<SetupAccount />} />
    <Route path="/onboarding-questions" element={<OnboardingQuestions />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />
    <Route path="/reset-password" element={<ResetPassword />} />
    <Route path="/setup-password" element={<SetupPassword />} />
    <Route path="/change-password" element={<ChangePassword />} />
    <Route path="/oauth-success" element={<OAuthSuccess />} />
    <Route path="/admin/unlock" element={<AdminUnlock />} />
    {/* iter-230g — Backend `_calculate_vendor_redirect` (auth.py:494-505)
        returns `/verify-identity` and `/set-password` for pending vendors
        whose verification or password setup is incomplete. Without these
        aliases, /verify-identity and /set-password resolved to NO matching
        route → React Router rendered nothing → mobile vendors saw a blank
        screen after login or after completing a password reset and trying
        to re-login. Aliases map them onto the existing pages. */}
    <Route path="/verify-identity" element={<Navigate to="/setup-account" replace />} />
    <Route path="/set-password" element={<SetupPassword />} />
    <Route path="/" element={<Navigate to="/login" />} />
  </>
);
